"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var styled_components_1 = __importStar(require("styled-components"));

var styled_system_1 = require("styled-system");

var theme_get_1 = require("@styled-system/theme-get");

var invariant_1 = __importDefault(require("invariant"));

var BULLET_SIZE = '0.5em';

var getItemBottomSpace = function getItemBottomSpace(props) {
  return styled_system_1.style({
    prop: 'size',
    cssProperty: 'margin-bottom',
    key: 'space',
    transformValue: function transformValue(x, scale) {
      var mode = props.mode;

      if (mode === 'compact') {
        return x === 'lg' ? scale['xs'] : '0';
      }

      return scale['lg'];
    }
  });
};

var prefixColor = theme_get_1.themeGet('colors.text.primary');
var OrderedListItem = styled_components_1.default.li(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n  counter-increment: li;\n\n  &::before {\n    content: counter(li) '.';\n    display: inline-block;\n    color: ", ";\n    width: ", ";\n    text-align: right;\n  }\n"], ["\n  ", "\n  counter-increment: li;\n\n  &::before {\n    content: counter(li) '.';\n    display: inline-block;\n    color: ", ";\n    width: ", ";\n    text-align: right;\n  }\n"])), getItemBottomSpace, prefixColor, theme_get_1.themeGet('space.lg'));
var UnorderedListItem = styled_components_1.default.li(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", ";\n  &::before {\n    content: ' ';\n    width: ", ";\n    height: ", ";\n    border-radius: 0.25em;\n    margin-top: 0.5em;\n    margin-left: calc(", " - ", ");\n    display: inline-block;\n    vertical-align: top;\n    background-color: ", ";\n  }\n"], ["\n  ", ";\n  &::before {\n    content: ' ';\n    width: ", ";\n    height: ", ";\n    border-radius: 0.25em;\n    margin-top: 0.5em;\n    margin-left: calc(", " - ", ");\n    display: inline-block;\n    vertical-align: top;\n    background-color: ", ";\n  }\n"])), getItemBottomSpace, BULLET_SIZE, BULLET_SIZE, theme_get_1.themeGet('space.lg'), BULLET_SIZE, prefixColor);

exports.ListItem = function (props) {
  var parentAs = props.parentAs,
      restProps = __rest(props, ["parentAs"]);

  var Component = props.parentAs === 'ol' ? OrderedListItem : UnorderedListItem;
  return react_1.default.createElement(Component, __assign({}, restProps));
}; // We need to specify it otherwise it will not work in tests


exports.ListItem.displayName = 'ListItem';
var listFontSize = styled_system_1.style({
  prop: 'size',
  cssProperty: 'font-size',
  key: 'fontSizes.body'
});
var textColor = styled_system_1.style({
  prop: 'textColor',
  cssProperty: 'color',
  key: 'colors.text'
});
var InnerList = styled_components_1.default.ul(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  ", "\n  margin: 0;\n  padding: 0;\n  ", ";\n  list-style: none;\n\n  ", "\n\n  li {\n    display: flex;\n\n    &::before {\n      flex-shrink: 0;\n      margin-right: ", ";\n    }\n\n    &:last-of-type {\n      margin-bottom: 0;\n    }\n  }\n\n  ", "\n"], ["\n  ", "\n  margin: 0;\n  padding: 0;\n  ", ";\n  list-style: none;\n\n  ", "\n\n  li {\n    display: flex;\n\n    &::before {\n      flex-shrink: 0;\n      margin-right: ", ";\n    }\n\n    &:last-of-type {\n      margin-bottom: 0;\n    }\n  }\n\n  ", "\n"])), listFontSize, styled_system_1.space, textColor, theme_get_1.themeGet('space.xs'), function (_a) {
  var as = _a.as;
  return as === 'ol' && styled_components_1.css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      counter-reset: li;\n    "], ["\n      counter-reset: li;\n    "])));
});

var isListItem = function isListItem(child) {
  return child.type.displayName === "ListItem";
};

exports.List = function (props) {
  var type = props.type,
      children = props.children,
      restOfProps = __rest(props, ["type", "children"]);

  var listType = type === 'ordered' ? 'ol' : 'ul';
  return react_1.default.createElement(InnerList, __assign({
    as: listType
  }, restOfProps), react_1.default.Children.map(children, function (child) {
    var isValidChild = isListItem(child);
    invariant_1.default(isValidChild, 'List only accepts `List.Item` as children');
    return react_1.default.cloneElement(child, {
      parentAs: listType,
      size: props.size,
      mode: props.mode
    });
  }));
};

exports.List.defaultProps = {
  type: 'unordered',
  mode: 'compact',
  size: 'sm',
  textColor: 'default'
};
exports.List.Item = exports.ListItem;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;